import React, { useState, useEffect, useContext } from "react";
import PartnerLocationReadOnlyRow from "./PartnerLocationReadOnlyRow";
import PartnerLocationTableRow from "./PartnerLocationTableRow";
import UserPartnerDD from "./UserPartnerDD";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";


function PartnerLocationTable({ key, setPartnerLocation, loginId, companyId, userPartnerList, setSupplierId, supplierId }) {
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isPartnerLocationLoading, setIsPartnerLocationLoading] = useState(false);
	const [partnerLocations, setPartnerLocations] = useState([]);
	const [count, setCount] = useState(0);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		locationKey: 0,
		partnerKey: supplierId,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		if (supplierId > 0) {
			initialValues.partnerKey = supplierId;
			setFormValues({ ...formValues, ["partnerKey"]: supplierId });
			removeRowTable();
			setPartnerLocations([]);
			setIsPartnerLocationLoading(false);
			fetchPartnerLocations();
		}
	}, [supplierId]);

	const handleClose = (event) => {
		setPartnerLocation(false);
	};

	function fetchPartnerLocations() {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0
			|| !initialValues.loginId || !supplierId || supplierId === 0) {
			return;
		}
		resetCounter();
		setIsPartnerLocationLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true, companyId: initialValues.companyId,
				loginId: initialValues.loginId, partnerKey: supplierId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserPartnerLocation", "/Service/PartnerSubsService/GetUserPartnerLocation", requestOptions, retrievePartnerLocationSuccess, retrievePartnerLocationFail);
		} catch (error) {
			setIsPartnerLocationLoading(false);
			throw new Error(error.message);
		}
	}

	function retrievePartnerLocationFail(redirect) {
		setIsPartnerLocationLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.partnerGetLocFailed"));
	}

	function retrievePartnerLocationSuccess(responseData) {
		let fetchUserPartnerLocationsResponse;
		if (responseData) {
			fetchUserPartnerLocationsResponse = responseData.fetchUserPartnerLocationsResponse;
			if (fetchUserPartnerLocationsResponse && fetchUserPartnerLocationsResponse.errorCode === "0") {
				setPartnerLocations(fetchUserPartnerLocationsResponse.locations.slice())
			} else if (fetchUserPartnerLocationsResponse && fetchUserPartnerLocationsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserPartnerLocationsResponse) {
				setError(t("error.error") + " " + fetchUserPartnerLocationsResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsPartnerLocationLoading(false);
	}

	const handleDeleteClick = (event, partnerLocationItem, completeCallback) => {
		event.preventDefault();
		deletePartnerLocation(partnerLocationItem, completeCallback);
	};
	const deletePartnerLocation = (partnerLocationItem, completeCallback) => {
		let action = 3;
		if (partnerLocationItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			loginId: formValues.loginId,
			locationKey: partnerLocationItem.locationKey,
			partnerKey: partnerLocationItem.partnerKey,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserPartnerLocation", "/Service/PartnerSubsService/DeleteUserPartnerLocation", requestOptions, deletePartnerLocationSuccess, deletePartnerLocationFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deletePartnerLocationFail(redirect, completeCallback) {
		setError(t("error.userLocEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deletePartnerLocationSuccess(responseData, completeCallback) {
		let deleteUserPartnerLocationResponse;
		if (responseData) {
			deleteUserPartnerLocationResponse = responseData.deleteUserPartnerLocationResponse;
			if (deleteUserPartnerLocationResponse) {
				if (deleteUserPartnerLocationResponse.errorCode === "0") {
					resetRowTable();
					refreshPartnerLocation();
				} else {
					setError(t("error.error") + " " +
						deleteUserPartnerLocationResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (partnerLocations.length > 0) {
				partnerLocations.map((partnerLocationItem, index) => {
					if (partnerLocationItem.locationKey === setValues.locationKey && partnerLocationItem.partnerKey === setValues.partnerKey) {
						setError(t("error.locDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				savePartnerLocation(action, setValues, completeCallback);
			}
		}
	};
	const savePartnerLocation = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.loginId,
			companyId: formValues.companyId,
			locationKey: setValues.locationKey,
			partnerKey: setValues.partnerKey,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateUserPartnerLocation", "/Service/PartnerSubsService/AddUpdateUserPartnerLocation", requestOptions, savePartnerLocationSuccess, savePartnerLocationFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function savePartnerLocationFail(redirect, completeCallback) {
		setError(t("error.userLocEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function savePartnerLocationSuccess(responseData, completeCallback) {
		let addUpdateUserPartnerLocationResponse;
		if (responseData) {
			addUpdateUserPartnerLocationResponse = responseData.addUpdateUserPartnerLocationResponse;
			if (addUpdateUserPartnerLocationResponse) {
				if (addUpdateUserPartnerLocationResponse.errorCode === "0") {
					resetRowTable();
					refreshPartnerLocation();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserPartnerLocationResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshPartnerLocation() {
		fetchPartnerLocations();
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isPartnerLocationLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<UserPartnerDD loginId={loginId} companyId={companyId} setSupplierId={setSupplierId} userPartnerList={userPartnerList}
							supplierId = {supplierId} />
						</div>
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					{(supplierId > 0) ?
						<div className="row">
							<div className="col">
								<table className="list-table" role="table">
									<thead>
										<tr role="row">
											<th className="list-th">{t("page.loc.name")}</th>
											<th className="list-th">{t("page.status")}</th>
											<th className="list-th" style={{ maxWidth: "9vw" }}>
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</thead>
									<tbody role="rowgroup">
										{add && addRowTop &&
											<PartnerLocationTableRow
												index={count}
												partnerKey={supplierId}
												buyerKey={companyId}
												loginId={loginId}
												handleSubmit={handleSubmit}
												setError={setError}
												t={t}
												setAdd={setAdd}
												oddIdx={((partnerLocations.length % 2) > 0) ? true : false} />
										}
										{(partnerLocations.length > 0) ? (
											partnerLocations.map((partnerLocationItem, index) => (
												<PartnerLocationReadOnlyRow
													index={count}
													t={t}
													partnerLocationItem={partnerLocationItem}
													handleDeleteClick={handleDeleteClick}
													oddIdx={((index % 2) > 0) ? true : false}
													add={add}
													setError={setError}
												/>
											))
										) : (<></>)}
										{add && addRowBottom &&
											<PartnerLocationTableRow
												index={count}
												partnerKey={supplierId}
												buyerKey={companyId}
												loginId={loginId}
												handleSubmit={handleSubmit}
												setError={setError}
												t={t}
												setAdd={setAdd}
												oddIdx={((partnerLocations.length % 2) > 0) ? true : false} />
										}
									</tbody>
									{(partnerLocations.length > 10) ? (<tfoot>
										<tr role="row">
											<th className="list-th">{t("page.loc.name")}</th>
											<th className="list-th">{t("page.status")}</th>
											<th className="list-th" style={{ maxWidth: "9vw" }}>
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</tfoot>
									) : (<></>)}
								</table>
								<div className="row">
									<div className="col mt-3">
										{(error) ? (
											<div id="inerrorMessage1" className="errorblock">
												{error}
											</div>
										) : (<></>)}
									</div>
								</div>
								<div className="footer">
									<input
										type="button"
										name="edit-part-loc-close"
										id="edit-part-loc-close"
										className="btn btn-secondary btn-block" data-dismiss="modal"
										onClick={(e) => handleClose(e)}
										style={{ marginTop: "10px", marginBottom: "10px" }}
										value={closeText}
									></input>
								</div>
							</div>
						</div> :
						(!userPartnerList || userPartnerList.length === 0) ?
							<>
								<div className="row">
									<div className="col mt-3">
										<div id="inerrorMessage1" className="errorblock">
											{t("error.partnerReqd")}
										</div>
									</div>
								</div>
								<div className="footer">
									<input
										type="button"
										name="edit-part-loc-close"
										id="edit-part-loc-close"
										className="btn btn-secondary btn-block" data-dismiss="modal"
										onClick={(e) => handleClose(e)}
										style={{ marginTop: "10px", marginBottom: "10px" }}
										value={closeText}
									></input>
								</div>
							</> : (<></>)}
				</div>
				: null}
		</>
	);
}
export default PartnerLocationTable;